import { useAppSelector } from "./useAppSelector";

export default function useIsSmallDesktop(): boolean {
    return useAppSelector((state) => state?.page.isSmallDesktop)
}
